import React from 'react';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import {
  CheckCircle,
  XCircle,
  AlertCircle,
  Info,
  X
} from 'lucide-react';

const Alert = ({
  children,
  variant = 'info',
  title,
  dismissible = false,
  onDismiss,
  className,
  icon: CustomIcon,
  ...props
}) => {
  const variants = {
    success: {
      container: 'bg-success-50 text-success-800 border-success-200',
      icon: 'text-success-600',
      title: 'text-success-900',
    },
    danger: {
      container: 'bg-danger-50 text-danger-800 border-danger-200',
      icon: 'text-danger-600',
      title: 'text-danger-900',
    },
    warning: {
      container: 'bg-warning-50 text-warning-800 border-warning-200',
      icon: 'text-warning-600',
      title: 'text-warning-900',
    },
    info: {
      container: 'bg-primary-50 text-primary-800 border-primary-200',
      icon: 'text-primary-600',
      title: 'text-primary-900',
    },
  };

  const icons = {
    success: CheckCircle,
    danger: XCircle,
    warning: AlertCircle,
    info: Info,
  };

  const Icon = CustomIcon || icons[variant];
  const styles = variants[variant];

  return (
    <div
      className={twMerge(
        clsx(
          'rounded-lg border p-4',
          styles.container,
          className
        )
      )}
      role="alert"
      {...props}
    >
      <div className="flex">
        {Icon && (
          <div className="flex-shrink-0">
            <Icon className={clsx('h-5 w-5', styles.icon)} />
          </div>
        )}
        <div className="flex-1 ml-3">
          {title && (
            <h3 className={clsx('text-sm font-medium mb-1', styles.title)}>
              {title}
            </h3>
          )}
          <div className="text-sm">{children}</div>
        </div>
        {dismissible && (
          <div className="ml-auto pl-3">
            <button
              onClick={onDismiss}
              className={clsx(
                'inline-flex rounded-md p-1.5 hover:bg-black/5 focus:outline-none',
                styles.icon
              )}
            >
              <span className="sr-only">Dismiss</span>
              <X className="h-4 w-4" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Alert;